export default __webpack_public_path__ + "static/homepage-team2-891c4d84e0476036549fb5cbc6a0a3d3.png";